
import { TranslateResult } from 'vue-i18n'
import { Component, Prop, VModel, Vue } from 'nuxt-property-decorator'
import { NeoField, NeoSwitch, NeoTooltip } from '@kodadot1/brick'

@Component({ components: { NeoSwitch, NeoTooltip, NeoField } })
export default class BasicSwitch extends Vue {
  @VModel({ type: Boolean, required: true }) isSwitched!: string
  @Prop({ type: String, required: true }) label!: string
  @Prop({ type: String }) offLabel!: string
  @Prop({ type: String }) size!: string
  @Prop({ type: String }) type!: string
  @Prop({ type: String }) labelColor!: string
  @Prop({ type: String }) message!: string
  @Prop(Boolean) public disabled!: boolean

  get componentName(): string {
    return this.message ? 'NeoTooltip' : 'span'
  }

  get properLabel(): TranslateResult {
    const offLabel = this.offLabel || this.label
    return this.$t(this.isSwitched ? this.label : offLabel)
  }
}
